import { useEffect, useState } from "react";
import { api, type User } from "../lib/api";
import { layoutItems } from "../lib/videoLayout";
import { WhepPlayer } from "../components/WhepPlayer";
import type { CameraSummary } from "./CamerasPage";

export function LivePage({ user, sidebarCollapsed, onToggleSidebar }: { user: User; sidebarCollapsed: boolean; onToggleSidebar: () => void }) {
  const [slots, setSlots] = useState<Array<CameraSummary | null>>([]);
  const [activeAudioCameraId, setActiveAudioCameraId] = useState<string | null>(null);

  useEffect(() => {
    void api<CameraSummary[]>("/api/camera-options?scope=live").then((cameras) => {
      const arranged = layoutItems(cameras.filter((camera) => camera.enabled), user.cameraLayout, user.videoLayout);
      setSlots(arranged);
      setActiveAudioCameraId((current) => current && arranged.some((camera) => camera?.id === current) ? current : null);
    });
  }, [user.videoLayout, user.cameraLayout]);

  useEffect(() => {
    const muteHiddenLiveView = () => {
      if (document.visibilityState === "hidden") setActiveAudioCameraId(null);
    };
    document.addEventListener("visibilitychange", muteHiddenLiveView);
    return () => document.removeEventListener("visibilitychange", muteHiddenLiveView);
  }, []);

  const toggleAudio = (id: string, enabled: boolean) => setActiveAudioCameraId(enabled ? id : null);

  return <div className="live-page">
    <div className="page-heading">
      <div><p className="eyebrow">실시간 카메라</p><h2>실시간 보기</h2></div>
      <button type="button" className="btn btn-sm btn-outline-secondary sidebar-live-toggle" onClick={onToggleSidebar} title={sidebarCollapsed ? "왼쪽 메뉴 펼치기" : "왼쪽 메뉴를 접어 영상 넓게 보기"} aria-label={sidebarCollapsed ? "왼쪽 메뉴 펼치기" : "왼쪽 메뉴 접기"}><i className={`bi bi-layout-sidebar${sidebarCollapsed ? "-inset" : ""}`} /></button>
    </div>
    <div className={`live-grid ${user.videoLayout}`}>
      {slots.map((camera, index) => camera
        ? <WhepPlayer key={`${index}-${camera.id}`} cameraId={camera.id} cameraName={camera.name} canSnapshot={user.permissions.includes("snapshot.create")} canAudio={user.permissions.includes("audio.output")} audioActive={activeAudioCameraId === camera.id} onAudioToggle={toggleAudio} autoReconnect showDebug={user.permissions.includes("debug.view")} />
        : <div key={`${index}-empty`} className="camera-tile layout-empty-tile" aria-hidden="true" />)}
      {!slots.length && <div className="empty-state panel">접근 가능한 활성 카메라가 없습니다.</div>}
    </div>
  </div>;
}
